"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserPropTypes = exports.PageStatePropTypes = exports.Auth0UserPropTypes = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PageStatePropTypes = exports.PageStatePropTypes = _propTypes.default.shape({
  errors: []
});
const UserPropTypes = exports.UserPropTypes = _propTypes.default.shape({
  photo: _propTypes.default.string,
  name: _propTypes.default.string,
  email: _propTypes.default.string,
  firstName: _propTypes.default.string,
  lastName: _propTypes.default.string,
  mobile: _propTypes.default.string
});
const Auth0UserPropTypes = exports.Auth0UserPropTypes = _propTypes.default.shape({
  email: _propTypes.default.string,
  email_verified: _propTypes.default.bool,
  name: _propTypes.default.string,
  nickname: _propTypes.default.string,
  picture: _propTypes.default.string,
  sub: _propTypes.default.string,
  updated_at: _propTypes.default.string
});